const serverURL = process.env.REACT_APP_SERVER_URL;

export const apiUrl = (path) => `${serverURL}/${path}`;
export const isJsonString = (jsonString) => {
  try {
    JSON.parse(jsonString);
  } catch (e) {
    return false;
  }
  return true;
};
